import React from 'react'
import { Email, EmailOutlined, LocationOn, LocationOnOutlined, Phone } from '@mui/icons-material'
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material'
function Address_Email() {

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // Mobile screen check
      

  return (
    <Box sx={{  height: '100%', display: 'flex', gap: { xs: 1, md: 3 }, flexDirection: 'column', justifyContent: 'start', alignItems: 'start' }} >
        <Typography variant='h5' sx={{ ml: 2, mt: 2 }} >
          Contact
        </Typography>
        <Box sx={{ ml: 3, display: 'flex', gap: 2, justifyContent: 'left', alignItems: 'center',  }} >
          <LocationOnOutlined/>
          <Typography sx={{ fontSize: '0.9rem' }} >
            Viman Nagar, Pune - 411014 <br/>
            Maharashtra, India.
          </Typography>
        </Box>
        <Box sx={{ ml: 3, display: 'flex', gap: 2, justifyContent: 'left', alignItems: 'center' }} >
          <Phone/>
          <Typography sx={{ fontSize: '0.9rem' }} >
            +91 9637373615
          </Typography>
        </Box>
        <Box sx={{ ml: 3, display: 'flex', gap: 2, justifyContent: 'left', alignItems: 'center' }} >
          <EmailOutlined/>
          <Typography sx={{ fontSize: '0.9rem' }} >
            data.pi@zohomail.in
          </Typography>
        </Box>
    </Box>
  )
}

export default Address_Email
